import {
  GET_EVENTS_REQUEST,
  GET_EVENTS_REQUEST_SUCCESS,
  GET_MY_EVENTS_REQUEST,
  GET_MY_EVENTS_REQUEST_SUCCESS,
  GET_SINGLE_EVENT_REQUEST,
  GET_SINGLE_EVENT_REQUEST_SUCCESS,
  EVENT_GOING_REQUEST,
  EVENT_NOT_GOING_REQUEST,
  GET_ORG_EVENTS_REQUEST,
  GET_ORG_EVENTS_SUCCESS,
  RESET_EVENT_BY_ID_SUCCESS,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
} from '../constants/actionTypes';

const getOrgEventsRequest = (payload) => ({
  type: GET_ORG_EVENTS_REQUEST,
   payload,
});

const getOrgEventsSuccess = (payload) => ({
  type: GET_ORG_EVENTS_SUCCESS,
   payload,
});

const deleteEventsSuccess = (payload) => ({
  type: DELETE_EVENT_SUCCESS,
   payload,
});

const deleteEventsRequest = (payload) => ({
  type: DELETE_EVENT_REQUEST,
   payload,
});

const updateEventsSuccess = (payload) => ({
  type: UPDATE_EVENT_SUCCESS,
   payload,
});

const updateEventsRequest = (payload) => ({
  type: UPDATE_EVENT_REQUEST,
   payload,
});

const resetEventByIdRequest = (payload) => ({
  type: RESET_EVENT_BY_ID_SUCCESS,
   payload,
});

const getAllEvents = () => ({
  type: GET_EVENTS_REQUEST,
});

const getMyEvents = () => ({
  type: GET_MY_EVENTS_REQUEST,
});

const getSingleEvent = id => ({
  type: GET_SINGLE_EVENT_REQUEST,
  id,
});

const eventGoing = id => ({
  type: EVENT_GOING_REQUEST,
  id,
});

const eventNotGoing = id => ({
  type: EVENT_NOT_GOING_REQUEST,
  id,
});

const getAllEventsSuccess = payload => ({
  type: GET_EVENTS_REQUEST_SUCCESS,
  payload,
});

const getMyEventsSuccess = payload => ({
  type: GET_MY_EVENTS_REQUEST_SUCCESS,
  payload,
});

const getSingleEventSuccess = payload => ({
  type: GET_SINGLE_EVENT_REQUEST_SUCCESS,
  payload,
});

export {
  getAllEvents,
  getMyEvents,
  getAllEventsSuccess,
  getMyEventsSuccess,
  getSingleEvent,
  getSingleEventSuccess,
  eventGoing,
  eventNotGoing,
  resetEventByIdRequest,
  updateEventsRequest,
  updateEventsSuccess,
  deleteEventsRequest,
  deleteEventsSuccess,
  getOrgEventsSuccess,
  getOrgEventsRequest
};
